import { InlineAutocompleteMenu } from 'content-assistance-lib/autocomplete/InlineAutocompleteMenu';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { DOMParser } from 'hubspot-prosemirror/pm/model';
import { initContentAssistantSlashPluginState } from './utils';
import { mapEditorContext } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ContentAssistantInlineAutocompleteMenu({
  onInsert,
  onClose,
  getSelectedCommandParams,
  view,
  state,
  trackInteraction,
  usageDescription,
  selectedItem,
  pluginKey
}) {
  const editorContent = mapEditorContext(view.state);

  // other parameters to submit as part of the /command-executions api payload
  const parameters = getSelectedCommandParams ? getSelectedCommandParams(selectedItem.commandId, view, state) : {};
  const selectedCommand = Object.assign({}, selectedItem);
  selectedCommand.parameters = parameters;
  const onPromptComplete = text => {
    const tr = view.state.tr.setMeta(pluginKey, initContentAssistantSlashPluginState());
    if (onInsert) {
      onInsert(text, view, state, selectedCommand.commandId, tr);
    } else {
      const html = `${text.replaceAll('\n', '<br>')}`;
      const parser = new window.DOMParser();
      const element = parser.parseFromString(html, 'text/html');
      const node = DOMParser.fromSchema(view.state.schema).parse(element.body);
      tr.replaceWith(state.searchTextStartPos, state.currentCursorPos, node);
      view.dispatch(tr);
    }
  };
  return /*#__PURE__*/_jsx(Popover, {
    open: true,
    use: 'unstyled',
    placement: "bottom",
    content: /*#__PURE__*/_jsx(InlineAutocompleteMenu, {
      currentCommand: selectedCommand,
      onPromptComplete: onPromptComplete,
      onClose: onClose,
      trackInteraction: trackInteraction,
      editorContext: editorContent,
      usageDescription: usageDescription
    }),
    children: /*#__PURE__*/_jsx("span", {})
  });
}